import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import ProduttoriList from "@/pages/ProduttoriList";
import ProduttoreDetail from "@/pages/ProduttoreDetail";
import ProduttoriDaRivedere from "@/pages/ProduttoriDaRivedere";
import Mezzi from "@/pages/Mezzi";
import Geocoding from "@/pages/Geocoding";
import ImportPage from "@/pages/Import";
import Settings from "@/pages/Settings";
import GiroDelGiorno from "@/pages/GiroDelGiorno";
import RecuperiList from "@/pages/RecuperiList";
import Ritiri from "@/pages/Ritiri";
import StoricoCliente from "@/pages/StoricoCliente";
import ScadenzeSettings from "@/pages/ScadenzeSettings";
import LogoSettings from "@/pages/LogoSettings";
import FasceSettings from "@/pages/FasceSettings";
import Login from "@/pages/Login";
import ChangePassword from "@/pages/ChangePassword";
import SetupPin from "@/pages/SetupPin";
import UsersManagement from "@/pages/UsersManagement";
import LoginAttempts from "@/pages/LoginAttempts";
import Esportazioni from "@/pages/Esportazioni";
import SmtpSettings from "@/pages/SmtpSettings";
import ZoneSettings from "@/pages/ZoneSettings";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

const ADMIN_OFFICE = ["AMMINISTRATORE", "UFFICIO"];
const ADMIN_ONLY = ["AMMINISTRATORE"];
const ALL_ROLES = ["AMMINISTRATORE", "UFFICIO", "TRASPORTATORE"];

function HomeRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.mustChangePassword) return <Navigate to="/cambio-password" replace />;
  return <Navigate to={user.ruolo === "TRASPORTATORE" ? "/giro" : "/dashboard"} replace />;
}

function ProtectedLayout({ children, roles }) {
  return (
    <ProtectedRoute roles={roles}>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/cambio-password" element={
              <ProtectedRoute roles={ALL_ROLES}><ChangePassword /></ProtectedRoute>
            } />
            <Route path="/setup-pin" element={
              <ProtectedRoute roles={["TRASPORTATORE"]}><SetupPin /></ProtectedRoute>
            } />
            <Route path="/" element={<HomeRedirect />} />

            <Route path="/dashboard" element={<ProtectedLayout roles={ADMIN_OFFICE}><Dashboard /></ProtectedLayout>} />
            <Route path="/produttori" element={<ProtectedLayout roles={ADMIN_OFFICE}><ProduttoriList /></ProtectedLayout>} />
            <Route path="/produttori/da-rivedere" element={<ProtectedLayout roles={ADMIN_OFFICE}><ProduttoriDaRivedere /></ProtectedLayout>} />
            <Route path="/produttori/:id" element={<ProtectedLayout roles={ADMIN_OFFICE}><ProduttoreDetail /></ProtectedLayout>} />
            <Route path="/pianificazione" element={<Navigate to="/giro" replace />} />
            <Route path="/ritiri" element={<ProtectedLayout roles={ADMIN_OFFICE}><Ritiri /></ProtectedLayout>} />
            <Route path="/storico-cliente" element={<ProtectedLayout roles={ADMIN_OFFICE}><StoricoCliente /></ProtectedLayout>} />

            <Route path="/giro" element={<ProtectedLayout roles={ALL_ROLES}><GiroDelGiorno /></ProtectedLayout>} />
            <Route path="/recuperi" element={<ProtectedLayout roles={ADMIN_OFFICE}><RecuperiList /></ProtectedLayout>} />

            <Route path="/utenti" element={<ProtectedLayout roles={ADMIN_ONLY}><UsersManagement /></ProtectedLayout>} />
            <Route path="/login-attempts" element={<ProtectedLayout roles={ADMIN_ONLY}><LoginAttempts /></ProtectedLayout>} />
            <Route path="/esportazioni" element={<ProtectedLayout roles={ADMIN_OFFICE}><Esportazioni /></ProtectedLayout>} />
            <Route path="/settings" element={<ProtectedLayout roles={ADMIN_OFFICE}><Settings /></ProtectedLayout>} />
            <Route path="/settings/smtp" element={<ProtectedLayout roles={ADMIN_ONLY}><SmtpSettings /></ProtectedLayout>} />
            <Route path="/settings/mezzi" element={<ProtectedLayout roles={ADMIN_OFFICE}><Mezzi /></ProtectedLayout>} />
            <Route path="/settings/geocoding" element={<ProtectedLayout roles={ADMIN_OFFICE}><Geocoding /></ProtectedLayout>} />
            <Route path="/settings/import" element={<ProtectedLayout roles={ADMIN_OFFICE}><ImportPage /></ProtectedLayout>} />
            <Route path="/settings/fasce" element={<ProtectedLayout roles={ADMIN_ONLY}><FasceSettings /></ProtectedLayout>} />
            <Route path="/settings/scadenze" element={<ProtectedLayout roles={ADMIN_ONLY}><ScadenzeSettings /></ProtectedLayout>} />
            <Route path="/settings/logo" element={<ProtectedLayout roles={ADMIN_ONLY}><LogoSettings /></ProtectedLayout>} />
            <Route path="/settings/zone" element={<ProtectedLayout roles={ADMIN_OFFICE}><ZoneSettings /></ProtectedLayout>} />

            <Route path="*" element={<HomeRedirect />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
